import Button from "@app/components/move2Library/Button/Button"
import { ZoneDetailInformation } from "@app/components/zone/ZoneDetailInformation/ZoneDetailInformation"
import { useGetStrings, useGetZone } from "@app/store/service/cmsService"
import { Modal, useModal } from "@tecreation/funnel-components"

export default function ZoneInformationModal({ zoneId }) {
	const {
		data: { title, subTitle },
	} = useGetZone(zoneId, { defaultData: {} })
	const {
		data: { buttonClose },
	} = useGetStrings()
	const { hideModal } = useModal()

	return (
		<Modal ariaDescribedBy="zone-modal-subtitle" ariaLabelledBy="zone-modal-title">
			<Modal.Closer ariaLabel={buttonClose} />
			<Modal.Header>
				<h2 id="zone-modal-title" className="h-without-default-style">
					{title}
				</h2>
				<p id="zone-modal-subtitle" className="color-fg-secondary mt-1 f4">
					{subTitle}
				</p>
			</Modal.Header>

			<Modal.Body>
				<ZoneDetailInformation zoneId={zoneId} />
			</Modal.Body>

			<Modal.Footer className="flex flex-center">
				<Button style="primary" onClick={hideModal}>
					{buttonClose}
				</Button>
			</Modal.Footer>
		</Modal>
	)
}
